<ng-container *ngFor="let option of options">
  <button
    type="button"
    class="dropdown-item"
    [disabled]="
      isReactiveDisabled(option.disabled)
        ? (option.disabled | async)
        : !!option.disabled
    "
    (click)="onClick(option)"
    [ngClass]="{ 'text-danger': option.danger }"
  >
    {{ option.label | translate }}
  </button>

  <div *ngIf="option.divider" class="dropdown-divider"></div>
</ng-container>
